module.exports = __webpack_public_path__ + "static/img/home_img_figure.b0af9bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/home_img_figure.png
// module id = hcJt
// module chunks = 0